import _ from 'lodash'

export const getBasketItemByEventId = (basketData) => {
    const eventid = localStorage.getItem('eventid')

    if (_.isEmpty(basketData) || _.isNil(eventid)) return null

    const items = basketData?.items_tickets
    const item = items.find((i) => i?.event?.eventid === parseInt(eventid, 10))

    return item
}
